var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 6H7C5.34315 6 4 7.34315 4 9V11.3333V14V16.6667V19C4 20.6569 5.34315 22 7 22H14H21C22.6569 22 24 20.6569 24 19V16.6667V14V11.3333V9C24 7.34315 22.6569 6 21 6H14Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 11H23",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 16,
  width: 3,
  height: 3,
  rx: 1,
  fill: "currentColor"
})));
export { SvgCardIcon as ReactComponent };